// extracted by css-extract-rspack-plugin
var _1 = "attribute-label-EDqhXd";
var _2 = "attribute-label-EDqhXd";
var _3 = "card-GnuIQO";
var _4 = "complex-value-tUHnpA";
var _5 = "complex-value-tUHnpA";
var _6 = "diff-F058BY";
var _7 = "form-CWGzWs";
export { _1 as "attribute-label", _2 as "attributeLabel", _3 as "card", _4 as "complex-value", _5 as "complexValue", _6 as "diff", _7 as "form" }
